import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { patientsActions } from 'features/patients';

const usePatients = () => {
  const dispatch = useDispatch();
  const getPatients = useCallback(({ offset, query, source }) => dispatch(patientsActions.getPatients({ offset, query, source })), [dispatch]);
  const getPatient = useCallback(({ id, cable }) => dispatch(patientsActions.getPatient({ id, cable })), [dispatch]);
  const createPatient = useCallback(({ patient }) => dispatch(patientsActions.createPatient({ patient })), [dispatch]);
  const updatePatient = useCallback(patient => dispatch(patientsActions.updatePatient(patient)), [dispatch]);
  const deletePatient = useCallback(id => dispatch(patientsActions.deletePatient(id)), [dispatch]);
  const deleteLocalPatient = useCallback(id => dispatch(patientsActions.deleteLocalPatient(id)), [dispatch]);
  const clearLocalPatients = useCallback(() => dispatch(patientsActions.clearLocalPatients()), [dispatch]);
  const clearLocalActivePatient = useCallback(() => dispatch(patientsActions.clearLocalActivePatient()), [dispatch]);

  return {
    getPatients,
    getPatient,
    createPatient,
    updatePatient,
    deletePatient,
    deleteLocalPatient,
    clearLocalPatients,
    clearLocalActivePatient
  };
};

export default usePatients;